module.exports = __webpack_public_path__ + "img/到车管理.68aa59ef.svg";